/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentRental = (state) => {
    return get(state, ['currentRental', 'items'], []);
};

export const requestingCurrentRental = (state) => get(state, ['currentRental', 'requesting'], false);

export const errorRequestingCurrentRental = (state) => get(state, ['currentRental', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentRental,
    (currentRental) => {
        return get(currentRental, ['has_scheduled_changes'], false);
    },
);